import { render } from "./NotFound.vue?vue&type=template&id=09b9b6fb&scoped=true"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=09b9b6fb&scoped=true&lang=css"

import exportComponent from "/Users/lulua/Documents/lupanalua_oficial+dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09b9b6fb"]])

export default __exports__